export default "__VITE_ASSET__w7wyzt_0__"